<div class="mfa-setup-page">
    <!-- Header: back arrow + title -->
    <div class="mfa-header">
        <button class="mfa-back-btn" (click)="goBack()" aria-label="Back">&#8592;</button>
        <h1 class="mfa-main-title">{{'aumico_mfa_setup_step1_title' | i18next}}</h1>
    </div>

    <!-- Stepper -->
    <div class="mfa-stepper">
        <div class="mfa-step" [class.mfa-step--active]="currentStep === 1" [class.mfa-step--done]="currentStep > 1">
            <div class="mfa-step__circle">1</div>
            <span class="mfa-step__label">{{'aumico_mfa_setup_stepper_scan_qr' | i18next}}</span>
        </div>
        <div class="mfa-step__connector"></div>
        <div class="mfa-step" [class.mfa-step--active]="currentStep === 2" [class.mfa-step--done]="currentStep > 2">
            <div class="mfa-step__circle">2</div>
            <span class="mfa-step__label">{{'aumico_mfa_setup_stepper_verify' | i18next}}</span>
        </div>
        <div class="mfa-step__connector"></div>
        <div class="mfa-step" [class.mfa-step--active]="currentStep === 3">
            <div class="mfa-step__circle">3</div>
            <span class="mfa-step__label">{{'aumico_mfa_setup_stepper_backup_codes' | i18next}}</span>
        </div>
    </div>

    <!-- Step 1: Scan QR Code -->
    <ng-container *ngIf="currentStep === 1">
        <div *ngIf="isLoading" class="mfa-loading">
            <span>{{'aumico_mfa_loading' | i18next}}</span>
        </div>

        <div *ngIf="!isLoading && setupData" class="mfa-qr-container">
            <div class="mfa-qr-box">
                <img [src]="setupData.qrCodeDataUrl" alt="QR Code" class="mfa-qr-image" />
            </div>
            <p class="mfa-app-hint">{{'aumico_mfa_setup_step1_app_hint' | i18next}}</p>
            <div class="mfa-secret-key">
                <span class="mfa-secret-label">{{'aumico_mfa_setup_step1_manual_key' | i18next}}</span>
                <code class="mfa-secret-value">{{ setupData.secret }}</code>
            </div>
        </div>

        <div *ngIf="errorMessage" class="mfa-error">{{ errorMessage | i18next }}</div>

        <div class="mfa-actions">
            <ham-button [disabled]="isLoading || !setupData" (buttonClick)="goToVerifyStep()">
                {{'aumico_mfa_setup_step1_continue_button' | i18next}}
            </ham-button>
        </div>
    </ng-container>

    <!-- Step 2: Verify Code -->
    <ng-container *ngIf="currentStep === 2">
        <div class="mfa-otp-container">
            <div class="mfa-otp-inputs">
                <input
                    *ngFor="let ctrl of otpControls; let i = index"
                    #otpInput
                    class="mfa-otp-input"
                    type="text"
                    inputmode="numeric"
                    maxlength="1"
                    [value]="ctrl.value"
                    (input)="onOtpInput(i, $event)"
                    (keydown)="onOtpKeydown(i, $event)"
                    (paste)="onOtpPaste($event)"
                    autocomplete="one-time-code"
                />
            </div>
            <p class="mfa-otp-hint">{{'aumico_mfa_setup_step2_hint' | i18next}}</p>
        </div>

        <div *ngIf="errorMessage" class="mfa-error">{{ errorMessage | i18next }}</div>

        <div class="mfa-actions">
            <ham-button variant="white" (buttonClick)="goBack()">
                &#8592; {{'aumico_mfa_setup_step2_back_button' | i18next}}
            </ham-button>
            <ham-button [disabled]="!isOtpComplete || isLoading" (buttonClick)="onVerify()">
                {{'aumico_mfa_setup_step2_verify_button' | i18next}}
            </ham-button>
        </div>
    </ng-container>

    <!-- Step 3: Backup Codes -->
    <ng-container *ngIf="currentStep === 3">
        <p class="mfa-step3-description">{{'aumico_mfa_setup_step3_description' | i18next}}</p>

        <div class="mfa-backup-codes">
            <div *ngFor="let code of backupCodes" class="mfa-backup-code">
                <span class="mfa-backup-code__value">{{ code }}</span>
                <button class="mfa-backup-code__copy" (click)="copyToClipboard(code)" type="button" aria-label="Copy">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                </button>
            </div>
        </div>

        <div class="mfa-actions">
            <ham-button variant="white" (buttonClick)="downloadBackupCodes()">
                &#8595; {{'aumico_mfa_setup_step3_download_button' | i18next}}
            </ham-button>
            <ham-button (buttonClick)="onContinue()">
                {{'aumico_mfa_setup_step3_continue_button' | i18next}}
            </ham-button>
        </div>
    </ng-container>

    <p class="mfa-footer">{{'aumico_mfa_setup_footer' | i18next}}</p>
</div>
